@import '../../../theme.scss';

verdocs-template-build-tabs {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  flex: 0 0 50px;
  width: 100%;
  background: #ffffff;
  color: #72757d;
  border-bottom: 1px solid #dddddd;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
  font-family: $verdocs-primary-font;

  .tab {
    position: relative;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    height: 50px;
    padding: 0 4px;
    background: #e7e7e7;
    font-weight: 700;
    font-size: 12px;
    cursor: pointer;

    @media (min-width: 768px) {
      padding: 0 8px 0 24px;
      font-size: 14px;
    }

    svg {
      position: absolute;
      top: 0;
      right: -19px;
      z-index: 10;
      pointer-events: none;
      display: none;

      @media (min-width: 768px) {
        display: block;
      }
    }

    &.active {
      background: #ffffff;
      color: #707ae5;
    }

    &.disabled {
      cursor: default;
      color: #d1d5db;
    }
  }
}
